import {
  HStack,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useToast,
  Text,
  TableContainer,
  VStack,
  Divider,
  Checkbox,
  Input,
  Button,
  InputGroup,
  InputLeftElement,
  IconButton,
  Image,
  Box,
  Heading,
  SimpleGrid,
  Stack,
  useBreakpointValue,
  Flex,
  GridItem,
  Select,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MyLoading } from "../my-components/MyLoading";

import { useReactToPrint } from "react-to-print";
import dayjs from "dayjs";
import jalali from "jalali-dayjs";
import { CheckCircle2, CircleX, Download } from "lucide-react";

import {
  UpdateInvoiceDriver,
  ShowInvoiceByToken,
} from "../api/services/invoiceService";
import { PersianAlphabet } from "../api/services/enums/persianAlphabets.enum";

export const UpdateInvoiceDriverInfo = ({}) => {
  const contentRef = useRef();
  const reactToPrintFn = useReactToPrint({ contentRef: contentRef });
  const toast = useToast();
  const [itemsCount, setItemsCount] = useState(0);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [imagePreview, setImagePreview] = useState("");
  const isDesktop = useBreakpointValue({ base: false, md: true });
  dayjs.extend(jalali);
  const [formData, setFormData] = useState({
    id: 0,
    title: "",
    customer: 0,
    totalAmount: 0,
    paymentStatus: 0,
    chequeAmount: 0,
    chequeSerial: 0,
    chequeDate: "",
    paperMoneyDate: "",
    paperMoneyAmount: 0,
    paperMoneySerial: 0,
    trustIssueDate: "",
    invoiceGoods: [],
    description: "",
    isAccepted: false,
    isAcceptedByCustomer: false,
    imageFile: 0,
    driverNatCode: "",
    driverMobile: "",
    driver: "",
    driverCarNumber: "",
  });
  const [invoiceItems, setInvoiceItems] = useState([
    {
      uniqueId: Date.now().toString(),
      no: 1,
      good: 0,
      goodName: 0,
      price: 0,
      goodUnitName: "",
      quantity: 0,
      total: 0,
      description: "",
    },
  ]);
  const [carNoFirst, setCarNoFirst] = useState("");
  const [carNoAlphabet, setCarNoAlphabet] = useState("");
  const [carNoThird, setCarNoThird] = useState("");
  const [carNoForth, setCarNoForth] = useState("");

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const loadInvoiceData = async () => {
      setLoading(true);
      if (!token || token.length < 10) {
        toast({
          title: "خطا",
          description: "توکن شما در سیستم وجود ندارد",
          status: "error",
          duration: 3000,
          isClosable: false,
        });
        setTimeout(() => navigate("/NotFound"), 1000);
        return;
      }
      console.log(token);

      const res = await ShowInvoiceByToken(token);
      if (!res.success) {
        toast({
          title: "خطا",
          description: res.error,
          status: "error",
          duration: 3000,
          isClosable: false,
        });
        setLoading(false);
        setTimeout(() => navigate("/NotFound"), 1000);
        return;
      }

      setFormData({ ...res?.data });
      let items = 0;
      res?.data?.invoiceGoods?.forEach((element) => {
        items += element.quantity;
      });
      setItemsCount(items);
      setLoading(false);
    };
    loadInvoiceData();
  }, []);

  const validateForm = async (data) => {
    if (data?.driver?.length < 3 || !isNaN(Number(data?.driver))) {
      toast({
        title: "توجه",
        description: "نام یا نام خانوادگی صحیح نیست",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return false;
    }
    if (data?.driverNatCode?.length > 0 && data?.driverNatCode?.length != 10) {
      toast({
        title: "توجه",
        description: "شماره ملی صحیح نیست",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return false;
    }
    if (isNaN(Number(data?.driverNatCode))) {
      toast({
        title: "توجه",
        description: "شماره ملی باید به شکل عددی باشد",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return false;
    }
    if (data?.driverMobile?.length > 0 && data?.driverMobile?.length != 11) {
      toast({
        title: "توجه",
        description: "شماره موبایل  صحیح نیست",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return false;
    }
    if (isNaN(Number(data?.driverMobile))) {
      toast({
        title: "توجه",
        description: "شماره موبایل باید به شکل عددی باشد",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return false;
    }
    if (
      data?.driverCarNumber?.length > 0 &&
      (data?.driverCarNumber?.length < 8 ||
        isNaN(Number(data?.driverCarNumber)))
    ) {
      toast({
        title: "توجه",
        description: "شماره خودرو صحیح نیست",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return false;
    }
    if (
      data?.driver?.length == 0 &&
      data?.driverCarNumber?.length == 0 &&
      data?.driverNatCode?.length == 0
    ) {
      toast({
        title: "توجه",
        description: "باید حداقل یکی از مشخصات راننده یا خودرو را مشخص کنید",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return false;
    }

    return true;
  };

  const handleChangeFormData = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validateCarNumber = async () => {
    if (
      carNoFirst?.length > 0 &&
      (carNoFirst?.length != 2 ||
        isNaN(Number(carNoFirst)) ||
        Number(carNoFirst) == 0)
    ) {
      toast({
        title: "توجه",
        description: "قسمت اول پلاک خودرو صحیح نیست",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return false;
    }
    if (carNoAlphabet?.length > 0 && carNoAlphabet?.trim() == "") {
      toast({
        title: "توجه",
        description: " حروف پلاک خودرو صحیح نیست",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return false;
    }
    if (
      carNoThird?.length > 0 &&
      (carNoThird?.length != 3 ||
        isNaN(Number(carNoThird)) ||
        Number(carNoThird) == 0)
    ) {
      toast({
        title: "توجه",
        description: "قسمت سوم پلاک خودرو صحیح نیست",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return false;
    }
    if (
      carNoForth?.length > 0 &&
      (carNoForth?.length != 2 ||
        isNaN(Number(carNoForth)) ||
        Number(carNoForth) == 0)
    ) {
      toast({
        title: "توجه",
        description: "قسمت آخر پلاک خودرو صحیح نیست",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const tmpCarNo = carNoFirst + carNoAlphabet + carNoThird + carNoForth;
    const finalFormData = {
      driver: formData?.driver,
      driverCarNumber: tmpCarNo,
      driverMobile: formData?.driverMobile,
      driverNatCode: formData?.driverNatCode,
    };
    setFormData(finalFormData);
    const carValidate = await validateCarNumber();
    if (carValidate == false) return;

    const validate = await validateForm(finalFormData);
    if (validate == false) return;

    setLoading(true);
    const res = await UpdateInvoiceDriver(token, finalFormData);
    if (!res.success) {
      toast({
        title: "خطا",
        description: res.error,
        status: "error",
        duration: 3000,
        isClosable: false,
      });
      setLoading(false);
      setTimeout(() => navigate("/NotFound"), 1000);
      return;
    }
    toast({
      title: "توجه",
      description: "مشخصات نماینده یا راننده شما تایید شد",
      status: "success",
      duration: 3000,
      isClosable: false,
    });
    console.log(res.data);

    setTimeout(() => navigate("/home"), 1000);
    setLoading(false);
  };

  const handleChangeCarNo = async () => {
    setFormData({
      ...formData,
      driverCarNumber: carNoFirst + carNoAlphabet + carNoThird + carNoForth,
    });
  };

  return (
    <Box borderTopRadius="md" p={2} borderColor="gray.100" borderWidth="1px">
      <Flex mx={2} dir="rtl">
        <Flex direction="column">
          <Text fontFamily="Aseman" fontSize="2xl">
            شرکت تجارت آسانبر علیا
          </Text>
          <Text
            mx="auto"
            fontSize="xl"
            fontFamily="EnglishHeader"
            color="gray.300"
          >
            OLIAEI GROUP
          </Text>
        </Flex>
        <Box mr="auto" mt={2} boxSize="150px" maxH={5}>
          <Image
            borderRadius="10%"
            src="/assets/images/logos/logo1.jpg"
            objectFit="cover"
            target="_blank"
            rel="noopener noreferrer"
          />
        </Box>
      </Flex>
      <Box
        minH={isDesktop ? "85vh" : "90vh"}
        overflowY="auto"
        m={2}
        filter={loading ? "blur(10px)" : ""}
        textAlign="center"
      >
        <Flex direction="column" rowGap={1} alignItems="baseline" my={1}>
          <Flex dir="rtl">
            <Text fontFamily="iransans" fontSize="xs" ml={1}>
              شماره سریال
            </Text>
            <Text
              px={2}
              borderRadius="md"
              borderWidth={1}
              borderColor="black"
              fontFamily="iransans"
              fontSize="xs"
            >
              {formData?.id}
            </Text>
          </Flex>
          <Flex dir="rtl">
            <Text fontFamily="iransans" fontSize="xs" ml={1}>
              تاریخ
            </Text>
            <Text
              px={2}
              borderRadius="md"
              borderWidth={1}
              borderColor="black"
              fontFamily="iransans"
              fontSize="xs"
            >
              {dayjs(formData?.createdAt).locale("fa").format("YYYY/MM/DD")}
            </Text>
          </Flex>
          <Flex dir="rtl">
            <Text fontFamily="iransans" fontSize="xs" ml={1}>
              ساعت
            </Text>
            <Text
              px={3}
              borderRadius="md"
              borderWidth={1}
              borderColor="black"
              fontFamily="iransans"
              fontSize="xs"
            >
              {dayjs(formData.createdAt).locale("fa").format("HH:mm:ss")}
            </Text>
          </Flex>
        </Flex>
        <Box
          bg="gray.100"
          borderTopRadius="md"
          p={2}
          borderColor="gray.400"
          borderWidth="1px"
        >
          <Heading fontFamily="IranSans" size="md" mx="auto">
            ثبت مشخصات راننده
          </Heading>
        </Box>
        <Box
          p={1}
          borderColor="gray.200"
          borderWidth={1}
          borderBottomRadius="md"
        >
          <Flex direction="column">
            <Flex px={1} borderWidth={1} my={1} dir="rtl" direction="column">
              <Text fontFamily="iransans" mx="auto" bg="gray.200" width="full">
                مشخصات فروشنده
              </Text>
              <SimpleGrid p={1} columns={{ base: 1, md: 2, lg: 3 }} spacing={2}>
                <HStack>
                  <Text
                    fontFamily="iransans"
                    fontSize={isDesktop ? "md" : "xs"}
                  >
                    نام شخصی حقیقی/حقوقی :
                  </Text>
                  <Text fontFamily="iransans" fontSize="xs">
                    آسانسورلند
                  </Text>
                </HStack>
                <HStack>
                  <Text
                    fontFamily="iransans"
                    fontSize={isDesktop ? "md" : "xs"}
                  >
                    شماره اقتصادی :
                  </Text>
                  <Text fontFamily="iransans" fontSize="xs">
                    14012045705
                  </Text>
                </HStack>
                <HStack>
                  <Text
                    fontFamily="iransans"
                    fontSize={isDesktop ? "md" : "xs"}
                  >
                    شماره ثبت/ملی :
                  </Text>
                  <Text fontFamily="iransans" fontSize="xs">
                    609813
                  </Text>
                </HStack>
                <GridItem colSpan={{ lg: 2, md: 2, sm: 1 }}>
                  <HStack>
                    <Text
                      fontFamily="iransans"
                      fontSize={isDesktop ? "md" : "xs"}
                      ml={1}
                      minW="50px"
                    >
                      نشانی :
                    </Text>
                    <Text
                      textAlign="justify"
                      fontFamily="iransans"
                      fontSize="xs"
                    >
                      تهران - بزرگراه 65 متری فتح ، ابتدای لاین کندرو، جنب
                      پایگاه یکم شکاری، ساختمان شهر آسانسور یاران، طبقه 4،
                      واحد446
                    </Text>
                  </HStack>
                </GridItem>
                <HStack>
                  <Text
                    fontFamily="iransans"
                    fontSize={isDesktop ? "md" : "xs"}
                  >
                    کدپستی :
                  </Text>
                  <Text fontFamily="iransans" fontSize="xs">
                    1387836295
                  </Text>
                </HStack>
                <HStack>
                  <Text
                    fontFamily="iransans"
                    fontSize={isDesktop ? "md" : "xs"}
                  >
                    شماره تلفن :
                  </Text>
                  <Text fontFamily="iransans" fontSize="xs">
                    021-65812952
                  </Text>
                </HStack>
                <HStack>
                  <Text
                    fontFamily="iransans"
                    fontSize={isDesktop ? "md" : "xs"}
                  >
                    شماره همراه :
                  </Text>
                  <Text fontFamily="iransans" fontSize="xs">
                    09125793556
                  </Text>
                </HStack>
                <HStack>
                  <Text
                    fontFamily="iransans"
                    fontSize={isDesktop ? "md" : "xs"}
                  >
                    ایمیل :
                  </Text>
                  <Text fontFamily="iransans" fontSize="xs">
                    info@hesab-yaar.ir
                  </Text>
                </HStack>
              </SimpleGrid>
            </Flex>
            <Flex px={1} borderWidth={1} my={1} dir="rtl" direction="column">
              <Text fontFamily="iransans" mx="auto" bg="gray.200" width="full">
                مشخصات خریدار
              </Text>
              <SimpleGrid p={1} columns={{ base: 1, md: 2, lg: 3 }} spacing={2}>
                <HStack>
                  <Text
                    fontFamily="iransans"
                    fontSize={isDesktop ? "md" : "xs"}
                  >
                    نام شخصی حقیقی/حقوقی :
                  </Text>
                  <Text
                    fontFamily="iransans"
                    fontSize={isDesktop ? "md" : "xs"}
                  >
                    {formData?.customer?.customerGender +
                      " " +
                      formData?.customer?.customerFName +
                      " " +
                      formData?.customer?.customerLName}
                  </Text>
                </HStack>
                <HStack>
                  <Text
                    fontFamily="iransans"
                    fontSize={isDesktop ? "md" : "xs"}
                  >
                    شماره اقتصادی :
                  </Text>
                  <Text fontFamily="iransans" fontSize="xs"></Text>
                </HStack>
                <HStack>
                  <Text
                    fontFamily="iransans"
                    fontSize={isDesktop ? "md" : "xs"}
                  >
                    شماره ثبت/ملی :
                  </Text>
                  <Text fontFamily="iransans" fontSize="xs">
                    {formData?.customer?.customerNationalCode}
                  </Text>
                </HStack>
                <GridItem colSpan={{ lg: 2, md: 2, sm: 1 }}>
                  <HStack>
                    <Text
                      fontFamily="iransans"
                      fontSize={isDesktop ? "md" : "xs"}
                    >
                      نشانی :
                    </Text>
                    <Text
                      textAlign="justify"
                      fontFamily="iransans"
                      fontSize="xs"
                    >
                      {formData?.customer?.customerAddress}
                    </Text>
                  </HStack>
                </GridItem>
                <HStack>
                  <Text
                    fontFamily="iransans"
                    fontSize={isDesktop ? "md" : "xs"}
                  >
                    کدپستی :
                  </Text>
                  <Text fontFamily="iransans" fontSize="xs">
                    {formData?.customer?.customerPostalCode}
                  </Text>
                </HStack>
                <HStack>
                  <Text
                    fontFamily="iransans"
                    fontSize={isDesktop ? "md" : "xs"}
                  >
                    شماره تلفن :
                  </Text>
                  <Text fontFamily="iransans" fontSize="xs">
                    {formData?.customer?.customerPhone}
                  </Text>
                </HStack>
                <HStack>
                  <Text
                    fontFamily="iransans"
                    fontSize={isDesktop ? "md" : "xs"}
                  >
                    شماره همراه :
                  </Text>
                  <Text fontFamily="iransans" fontSize="xs">
                    {formData?.customer?.customerMobile}
                  </Text>
                </HStack>
              </SimpleGrid>
            </Flex>
          </Flex>
          <Flex px={1} borderWidth={1} my={1} dir="rtl" direction="column">
            <Text fontFamily="iransans" mx="auto" bg="gray.200" width="full">
              مشخصات کالا و خدمات
            </Text>
            <SimpleGrid
              columns={{ base: 1, md: 1, lg: 1 }}
              dir="rtl"
              mt={3}
              mb={5}
              rowGap={5}
            >
              <Stack w="full" align="stretch">
                <TableContainer
                  w="full"
                  mx="auto"
                  dir="rtl"
                  borderColor="gray.300"
                  borderRadius="md"
                  borderWidth={1}
                >
                  <Table
                    columnGap={5}
                    size={isDesktop ? "md" : "xs"}
                    variant="striped"
                  >
                    <Thead h="50px" borderBottomWidth={2}>
                      <Tr columnGap={5} bg="gray.300" textFillColor="black">
                        <Th
                          px={2}
                          fontFamily="IranSans"
                          fontSize={isDesktop ? "md" : "xs"}
                          textAlign="center"
                        >
                          ردیف
                        </Th>
                        <Th
                          px={2}
                          fontFamily="IranSans"
                          fontSize={isDesktop ? "md" : "xs"}
                          textAlign="center"
                        >
                          نام کالا
                        </Th>
                        <Th
                          px={2}
                          fontFamily="IranSans"
                          fontSize={isDesktop ? "md" : "xs"}
                          textAlign="center"
                        >
                          تعداد
                        </Th>
                        <Th
                          px={2}
                          fontFamily="IranSans"
                          fontSize={isDesktop ? "md" : "xs"}
                          textAlign="center"
                        >
                          واحد
                        </Th>
                        <Th
                          px={2}
                          fontFamily="IranSans"
                          fontSize={isDesktop ? "md" : "xs"}
                          textAlign="center"
                        >
                          فی
                        </Th>
                        <Th
                          px={2}
                          fontFamily="IranSans"
                          fontSize={isDesktop ? "md" : "xs"}
                          textAlign="center"
                        >
                          جمع کل
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {formData?.invoiceGoods?.map((item, index) => (
                        <Tr key={item.no}>
                          <Td>
                            <Text
                              fontFamily="IranSans"
                              fontSize={isDesktop ? "md" : "xs"}
                              textAlign="center"
                            >
                              {index + 1}
                            </Text>
                          </Td>
                          <Td>
                            <Text
                              fontFamily="IranSans"
                              fontSize={isDesktop ? "md" : "xs"}
                              textAlign="center"
                            >
                              {item?.good?.goodName}
                            </Text>
                          </Td>
                          <Td>
                            <Text
                              fontFamily="IranSans"
                              fontSize={isDesktop ? "md" : "xs"}
                              textAlign="center"
                            >
                              {item?.quantity}
                            </Text>
                          </Td>
                          <Td>
                            <Text
                              fontFamily="IranSans"
                              fontSize={isDesktop ? "md" : "xs"}
                              textAlign="center"
                            >
                              {item?.good?.goodUnit?.unitName}
                            </Text>
                          </Td>

                          <Td>
                            <Text
                              fontFamily="IranSans"
                              fontSize={isDesktop ? "md" : "xs"}
                              textAlign="center"
                            >
                              {Number(item?.price).toLocaleString()}{" "}
                            </Text>
                          </Td>
                          <Td>
                            <Text
                              fontFamily="IranSans"
                              fontSize={isDesktop ? "md" : "xs"}
                              textAlign="center"
                            >
                              {Number(
                                item?.quantity * item?.price
                              ).toLocaleString()}
                            </Text>
                          </Td>
                        </Tr>
                      ))}
                      <Tr>
                        <Td colSpan={4} />
                        <Td colSpan={2}>
                          <VStack bg="gray.100" m={1}>
                            <HStack mx="auto">
                              <Text
                                fontFamily="IranSans"
                                fontSize={isDesktop ? "md" : "xs"}
                              >
                                تعداد کل :
                              </Text>
                              <Text
                                fontFamily="IranSans"
                                fontSize={isDesktop ? "md" : "xs"}
                              >
                                {itemsCount} مورد
                              </Text>
                            </HStack>
                            <Divider />
                            <HStack mx="auto">
                              <Text
                                fontFamily="IranSans"
                                fontSize={isDesktop ? "md" : "xs"}
                              >
                                مبلغ نهایی :
                              </Text>
                              <Text
                                fontFamily="IranSans"
                                fontSize={isDesktop ? "md" : "xs"}
                              >
                                {Number(formData?.totalAmount).toLocaleString()}
                              </Text>
                            </HStack>
                          </VStack>
                        </Td>
                      </Tr>
                    </Tbody>
                  </Table>
                </TableContainer>
              </Stack>
            </SimpleGrid>
          </Flex>
          <Flex px={1} borderWidth={1} my={1} dir="rtl" direction="column">
            <Text fontFamily="iransans" mx="auto" bg="gray.200" width="full">
              مشخصات نماینده یا راننده
            </Text>
            <SimpleGrid
              columns={{ base: 1, md: 2, lg: 3 }}
              dir="rtl"
              mt={3}
              mb={2}
              rowGap={5}
              columnGap={5}
              as="form"
              onSubmit={handleSubmit}
            >
              <HStack>
                <Text
                  textAlign={"right"}
                  width={"150px"}
                  fontFamily="iransans"
                  fontSize={isDesktop ? "md" : "xs"}
                >
                  نام و نام خانوادگی
                </Text>
                <Input
                  name="driver"
                  value={formData.driver}
                  onChange={handleChangeFormData}
                />
              </HStack>
              <HStack>
                <Text
                  textAlign={"right"}
                  width={"150px"}
                  fontFamily="iransans"
                  fontSize={isDesktop ? "md" : "xs"}
                >
                  کد ملی
                </Text>
                <Input
                  isInvalid={
                    (formData?.driverNatCode !== undefined &&
                      formData?.driverNatCode?.length > 0 &&
                      formData?.driverNatCode?.length != 10) ||
                    isNaN(Number(formData?.driverNatCode))
                  }
                  maxLength={10}
                  name="driverNatCode"
                  value={formData?.driverNatCode}
                  onChange={handleChangeFormData}
                />
              </HStack>
              <HStack>
                <Text
                  maxLength={11}
                  textAlign={"right"}
                  width={"150px"}
                  fontFamily="iransans"
                  fontSize={isDesktop ? "md" : "xs"}
                >
                  موبایل
                </Text>
                <Input
                  isInvalid={
                    (formData?.driverMobile?.length > 0 &&
                      formData?.driverMobile?.length != 11) ||
                    isNaN(Number(formData?.driverMobile))
                  }
                  maxLength={11}
                  type="text"
                  name="driverMobile"
                  value={formData?.driverMobile}
                  onChange={handleChangeFormData}
                />
              </HStack>
              <HStack>
                <Text
                  textAlign={"right"}
                  width={"150px"}
                  fontFamily="iransans"
                  fontSize={isDesktop ? "md" : "xs"}
                >
                  پلاک خودرو
                </Text>
                <Input
                  isInvalid={
                    carNoForth?.length > 0 &&
                    (carNoForth?.length != 2 ||
                      isNaN(Number(carNoForth)) ||
                      Number(carNoForth) == 0)
                  }
                  fontFamily="iransans"
                  fontSize="sm"
                  width="100px"
                  type="text"
                  maxLength={2}
                  name="carNoForth"
                  value={carNoForth}
                  onChange={(e) => {
                    setCarNoForth(e.target.value);
                    handleChangeCarNo();
                  }}
                />
                <Input
                  fontFamily="iransans"
                  fontSize="sm"
                  width="120px"
                  isInvalid={
                    carNoThird?.length > 0 &&
                    (carNoThird?.length != 3 ||
                      isNaN(Number(carNoThird)) ||
                      Number(carNoThird) == 0)
                  }
                  maxLength={3}
                  type="text"
                  name="carNoThird"
                  value={carNoThird}
                  onChange={(e) => {
                    setCarNoThird(e.target.value);
                    handleChangeCarNo();
                  }}
                />
                <Select
                  isInvalid={carNoFirst?.length > 0 && carNoAlphabet == ""}
                  fontFamily="iransans"
                  fontSize="sm"
                  placeholder="حرف پلاک"
                  name="carNoAlpabet"
                  value={carNoAlphabet}
                  dir="ltr"
                  width="220px"
                  onChange={(e) => {
                    setCarNoAlphabet(e.target.value);
                    handleChangeCarNo();
                  }}
                >
                  {PersianAlphabet.map((p) => (
                    <option key={p.key} value={p.key}>
                      {p.value}
                    </option>
                  ))}
                </Select>
                <Input
                  isInvalid={
                    carNoFirst?.length > 0 &&
                    (carNoFirst?.length != 2 ||
                      isNaN(Number(carNoFirst)) ||
                      Number(carNoFirst) == 0)
                  }
                  fontFamily="iransans"
                  fontSize="sm"
                  width="100px"
                  dir="ltr"
                  type="text"
                  maxLength={2}
                  name="carNoFirst"
                  value={carNoFirst}
                  onChange={(e) => {
                    setCarNoFirst(e.target.value);
                    handleChangeCarNo();
                  }}
                />
                <Input
                  hidden="true"
                  name="driverCarNumber"
                  value={formData?.driverCarNumber}
                  onChange={handleChangeFormData}
                />
              </HStack>
              <GridItem colSpan={{ lg: 3, md: 2, sm: 1 }}>
                <HStack>
                  <Checkbox
                    alignItems={isDesktop ? "center" : "start"}
                    name="isAcceptedByCustomer"
                    isChecked={formData?.isAcceptedByCustomer}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        isAcceptedByCustomer: e.target.checked,
                      })
                    }
                  >
                    <Text
                      fontFamily="iransans"
                      fontSize={isDesktop ? "md" : "xs"}
                      textAlign="justify"
                      color="maroon"
                    >
                      اینجانب
                      {" " +
                        formData?.customer?.customerFName +
                        " " +
                        formData?.customer?.customerLName +
                        " "}
                      اطلاعات نماینده / راننده خود را ثبت کرده و تائید می نمایم.
                      بدیهی است پس از تحویل بار کلیه مسئولیت های صحت و سلامت
                      اقلام بر عهده نماینده / راننده اینجانب می باشد.
                    </Text>
                  </Checkbox>
                </HStack>
              </GridItem>
              <GridItem colSpan={{ lg: 3, md: 2, sm: 1 }}>
                <Divider />
              </GridItem>
              <GridItem colSpan={{ lg: 3, md: 2, sm: 1 }}>
                <Flex px={1} my={1} dir="rtl" direction="column" rowGap={2}>
                  <Button
                    isDisabled={!formData?.isAcceptedByCustomer}
                    type="submit"
                    colorScheme="blue"
                    leftIcon={<CheckCircle2 />}
                  >
                    تایید
                  </Button>
                  {/* <Button
                    isDisabled={!formData?.isAcceptedByCustomer}
                    colorScheme="green"
                    onClick={reactToPrintFn}
                    leftIcon={<Download />}
                  >
                    دانلود سند خروج کالا
                  </Button> */}
                </Flex>
              </GridItem>
            </SimpleGrid>
          </Flex>
        </Box>
      </Box>
      {loading && <MyLoading />}
      {/* <Box hidden={true}>
        <InvoicePdf ref={contentRef} />
      </Box> */}
    </Box>
  );
};
